import { supabase } from "@/integrations/supabase/client";

const CACHE_PREFIX = "client_onboarding_done_v1:";

/** Remember completion locally so the gate never re-blocks on a flaky network. */
export function markOnboardingComplete(userId: string) {
  try {
    window.localStorage.setItem(CACHE_PREFIX + userId, "1");
  } catch {
    /* storage unavailable — fall back to the network check */
  }
}

export function cachedOnboardingComplete(userId: string): boolean {
  try {
    return window.localStorage.getItem(CACHE_PREFIX + userId) === "1";
  } catch {
    return false;
  }
}

/**
 * True when this athlete has finished the intake questionnaire.
 * On any error we return true (fail open) so a backend hiccup can never
 * lock an existing athlete out of their app.
 */
export async function fetchOnboardingComplete(userId: string): Promise<boolean> {
  if (cachedOnboardingComplete(userId)) return true;
  const { data, error } = await supabase
    .from("client_onboarding")
    .select("completed_at")
    .eq("user_id", userId)
    .maybeSingle();
  if (error) return true;
  const done = Boolean(data?.completed_at);
  if (done) markOnboardingComplete(userId);
  return done;
}
